import React from 'react';

const IcArrowFillRoundDownGrey = () => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_2551_21454)'>
                <circle cx='12' cy='12' r='12' fill='#F7F7F8' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M7.10493 9.80503C6.83156 10.0784 6.83156 10.5216 7.10493 10.795L11.5049 15.195C11.7783 15.4683 12.2215 15.4683 12.4949 15.195L16.8949 10.795C17.1682 10.5216 17.1682 10.0784 16.8949 9.80503C16.6215 9.53166 16.1783 9.53166 15.9049 9.80503L11.9999 13.7101L8.09488 9.80503C7.82151 9.53166 7.37829 9.53166 7.10493 9.80503Z'
                    fill='#989BA2'
                />
            </g>
            <defs>
                <clipPath id='clip0_2551_21454'>
                    <rect width='24' height='24' rx='12' fill='white' />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IcArrowFillRoundDownGrey;
